import React, { useEffect, useState } from "react";

import { scaleVertical, scaleHorizontal } from "../../../styles/responsive";
import { Optometry } from "../../../Assets/images";
import { useEyeStore } from "../../../Store/useEyeReport";
import GlobalStyle from "../../../styles/GlobalStyle";
import { V2ReportStyle } from "../../../styles/V2ReportStyle";
import { PALLETTE } from "../../../utils/theme";
import { ExaminationIconSvg } from "../../../utils/Svgs";
import SectionHeading from "../../UI/SectionHeading";
import StatusLabel from "../../UI/StatusLabel";

const RenderItem = ({ item }: { item: any }) => {
  return (
    <div
      style={{
        ...V2ReportStyle.card,
        position: "relative",
        paddingBottom: scaleVertical(30),
        width: "90%",
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          ...V2ReportStyle.flexRowCenter,
          justifyContent: "space-between",
          position: "absolute",
          width: "90%",
          left: "5%",
          top: "10%",
        }}
      >
        <span
          style={{
            ...GlobalStyle.blackBoldText,
            fontSize: "2.2rem",
          }}
        >
          Vision
        </span>

        <StatusLabel lable={item?.label} />
      </div>

      <div
        style={{
          ...V2ReportStyle.flexColumnCenter,
          justifyContent: "center",
          alignItems: "center",
          marginTop: 40,
        }}
      >
        <div
          style={{
            ...V2ReportStyle.label,
            backgroundColor: PALLETTE.background,
          }}
        >
          <span
            style={{
              ...GlobalStyle.blackBoldText,
              fontSize: "2rem",
              color: PALLETTE.selectedBlue,
            }}
          >
            {item?.title}
          </span>
        </div>

        <img
          src={Optometry}
          alt="Optometry"
          style={{
            height: scaleVertical(175),
            width: "auto",
            objectFit: "contain",
          }}
        />

        <div
          style={{
            ...V2ReportStyle.flexRowCenter,
            justifyContent: "center",
            gap: scaleHorizontal(30),
          }}
        >
          <div
            style={{
              ...V2ReportStyle.eyeBox,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <span
              style={{
                ...GlobalStyle.blackExtraBoldText,
                fontSize: "2.5rem",
                color: PALLETTE.orange,
              }}
            >
              {item?.leftEye || "N/A"}
            </span>
          </div>

          <div
            style={{
              ...V2ReportStyle.eyeBox,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <span
              style={{
                ...GlobalStyle.blackExtraBoldText,
                fontSize: "2.5rem",
                color: PALLETTE.orange,
              }}
            >
              {item?.rightEye || "N/A"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const OptometryExamination = () => {
  const { eyeReportData } = useEyeStore();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const isNormalVision = (rightEye?: string, leftEye?: string) => {
    const normalValues = ["6/6", "N/A"];

    return (
      normalValues.includes(rightEye || "") &&
      normalValues.includes(leftEye || "")
    );
  };

  const aidedCard = {
    id: 1,
    title: "With Spectacles",
    rightEye: eyeReportData?.visualAcuity?.RightEye?.aided,
    leftEye: eyeReportData?.visualAcuity?.LeftEye?.aided,
    label: isNormalVision(
      eyeReportData?.visualAcuity?.RightEye?.aided,
      eyeReportData?.visualAcuity?.LeftEye?.aided,
    )
      ? "Normal"
      : "Need Attention",
  };

  const unaidedCard = {
    id: 2,
    title: "Without Spectacles",
    rightEye: eyeReportData?.visualAcuity?.RightEye?.unaided,
    leftEye: eyeReportData?.visualAcuity?.LeftEye?.unaided,
    label: isNormalVision(
      eyeReportData?.visualAcuity?.RightEye?.unaided,
      eyeReportData?.visualAcuity?.LeftEye?.unaided,
    )
      ? "Normal"
      : "Need Attention",
  };

  // const aidedCard = {
  //   id: 1,
  //   title: "With Spectacles",
  //   rightEye: eyeReportData?.visualAcuity?.RightEye?.aided,
  //   leftEye: eyeReportData?.visualAcuity?.LeftEye?.aided,
  //   label:
  //     eyeReportData?.visualAcuity?.RightEye?.aided === "6/6" &&
  //     eyeReportData?.visualAcuity?.LeftEye?.aided === "6/6"
  //       ? "Normal"
  //       : "Need Attention",
  // };

  // const unaidedCard = {
  //   id: 2,
  //   title: "Without Spectacles",
  //   rightEye: eyeReportData?.visualAcuity?.RightEye?.unaided,
  //   leftEye: eyeReportData?.visualAcuity?.LeftEye?.unaided,
  //   label:
  //     eyeReportData?.visualAcuity?.RightEye?.unaided === "6/6" &&
  //     eyeReportData?.visualAcuity?.LeftEye?.unaided === "6/6"
  //       ? "Normal"
  //       : "Need Attention",
  // };

  const data = [
    ...(eyeReportData?.visualAcuity?.RightEye?.aided ||
    eyeReportData?.visualAcuity?.LeftEye?.aided
      ? [aidedCard]
      : []),

    ...(eyeReportData?.visualAcuity?.RightEye?.unaided ||
    eyeReportData?.visualAcuity?.LeftEye?.unaided
      ? [unaidedCard]
      : []),
  ];
  console.log("EYE data", JSON.stringify(data, null, 2));

  if (data.length === 0) return null;

  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    const distance = touchStart - touchEnd;

    if (distance > 50) {
      setCurrentIndex((prev) => (prev === data.length - 1 ? 0 : prev + 1));
    }

    if (distance < -50) {
      setCurrentIndex((prev) => (prev === 0 ? data.length - 1 : prev - 1));
    }
  };

  return (
    <>
      <SectionHeading
        icon={<ExaminationIconSvg />}
        title="Optometry Examination"
      />

      <div
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        style={{
          position: "relative",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            transform: `translate3d(-${currentIndex * 100}%, 0, 0)`,
            transition: "transform 0.35s ease-in-out",
          }}
        >
          {data.map((item) => (
            <div
              key={item.id}
              style={{
                flex: "0 0 100%",
                width: "100%",
                minWidth: "100%",
                boxSizing: "border-box",
                backgroundColor: PALLETTE.white,
                borderRadius: "0.625rem",
              }}
            >
              <RenderItem item={item} />
            </div>
          ))}
        </div>

        {data.length > 1 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 8,
              marginTop: scaleVertical(12),
            }}
          >
            {data.map((_, index) => (
              <div
                key={index}
                onClick={() => setCurrentIndex(index)}
                style={{
                  width: currentIndex === index ? 20 : 8,
                  height: 8,
                  borderRadius: 20,
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  backgroundColor:
                    currentIndex === index ? PALLETTE.selectedBlue : "#D9D9D9",
                }}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default OptometryExamination;
